<template>
    <div class="contract-generation">
        <div class="page-title">
            <div class="title">
                <h1>Gerador de Documentos e Contratos</h1>
                <p>Gerencie os modelos de contratos para as propostas.</p>
            </div>

            <div v-if="total" class="flex">
                <ui-search-box event="contract-generation" placeholder="Buscar Contrato" @input="searchInput" />
            </div>

            <div class="flex">
                <a href="#" class="button-link" @click="openModal('instructions')">
                    <i class="fal fa-user-graduate"/> Aprenda como utilizar este recurso
                </a>

                <ui-button
                    v-if="total"
                    type="submit"
                    design="md primary"
                    @click="openSidebar('new-contract-generation', 'fields-mapping')">
                    Cadastrar Contrato
                    <i class="fal fa-plus"/>
                </ui-button>
            </div>
        </div>

        <div v-if="!total" class="page content-center">
            <ui-page-message
                :text="text"
                :action="go"
                :btn-text="btnText"
                :btn-icon="btnIcon"
                icon="fal fa-file-contract" />
        </div>

        <div v-if="total" class="page">
            <ui-data-table
                :columns="tableColumns"
                :sort-by="{ value: 'updated_at', dir: 'desc' }"
                :per-page="10"
                :borders="true"
                :control-fixed="true"
                name="contractGeneration"
                service="contractGeneration"
                search-event="contract-generation"
                tr-component="contract-generation/table-line"
                not-found-icon="fal fa-file-contract"
                not-found-text="Não existe nenhum contrato cadastrado" />
        </div>

        <ui-sidebar-new />
        <ui-sidebar-edit />
        <ui-modal-instructions />
        <ui-doc-preview v-if="contractPreview" :doc-name="contractPreview.name" name="sales-settings-contract-generation-preview" :url="contractPreview.files.url" />

        <ui-modal-message
            name="delete-form"
            service="contractGeneration"
            title="Deseja realmente excluir?"
            text="Cuidado, esta ação não poderá ser desfeita."
            btn-type="danger"
            btn-text="Confirmar" />
    </div>
</template>

<script>
	import { uiDataTable, uiPageMessage, uiSearchBox, uiDocPreview } from "@/components/ui"
	import uiModalInstructions from "./modal-instructions"
	import { uiModalMessage } from "@/components/ui/modal"
	import uiSidebarEdit from "./sidebar-edit"
	import uiSidebarNew	from "./sidebar-new"
	import { uiButton }	from "@/components/ui/buttons"

	export default {
		name: 'settings-contract-generation',

		components: {
			uiButton,
			uiDataTable,
			uiPageMessage,
			uiSearchBox,
			uiSidebarNew,
			uiSidebarEdit,
			uiModalInstructions,
			uiModalMessage,
			uiDocPreview
		},

		data() {
			return {
				searchInputValue: "",
				contractPreview: null,
				total: true,
				load: false,
				tableColumns: [
					{
						title: "Descrição",
						size: "",
						data: 'name',
						sortable: true,
					},
					{
						title: "Empreendimento",
						size: "",
						class: "h-xs"
					},
					{
						title: "Criado em",
						size: "",
						class: "h-xs",
					},
					{
						title: "Atualizado em",
						size: "",
						class: "h-xs",
						data: 'updated_at',
						sortable: true,
					},
					{
						title: "",
						size: "40",
					},
				],
				text: "<p>Cadastre os modelos de <strong>contratos</strong> de compra e venda e vincule-os aos</p> <p>seus produtos para agilizar o processo de venda.</p>",
				btnText: "Cadastrar Contrato",
				btnIcon: "fal fa-plus",
			}
		},

		created() {
			this.loadData()
		},

		mounted() {
			this.$root.$on('sales-settings-contract-generation-open-preview', (data) => {
				this.contractPreview = data

				this.$nextTick(() => {
					this.$root.$emit('modal-open-sales-settings-contract-generation-preview')
				})
			})
		},

		methods: {
			searchInput() {
				this.searchInputValue = event.target.value
				this.$store.dispatch('contractGeneration/searchInputsData', this.searchInputValue)
			},
			openSidebar(name, id) {
				/**
                 * Emite o evento do Google Analytics
                 */
                this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: "vuejs-gerar contrato",
                    action: "click",
                    label: "Clique no botão gerar contrato",
                })

				this.$root.$emit("sidebar-open-" + name, id)
				this.$store.dispatch("contractGeneration/setSidebarInputsData", true)
			},
			loadData() {
				this.load = true
				let timer = setInterval(() => {
					this.load = false
					clearInterval(timer)
				}, 1000)
			},
			go() {
				this.total = 1
			},
			openModal(name) {
				/**
                 * Emite o evento do Google Analytics
                 */
                this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: "vuejs-gerar contrato",
                    action: "click",
                    label: "Tutorial gerador de contrato",
                })

				this.$root.$emit("modal-open-" + name)
			},
			closeModal() {
				this.$root.$emit("modal-close-" + name)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
